/** @jsx jsx */
import { jsx } from '@emotion/core';
import { SafePureComponent } from '../../../../utils/SafePureComponent';
import PropTypes from 'prop-types';
import { modalIds, ModalsConsumer } from '../../../../contexts/ModalsContext';
import get from 'lodash/get';
import {
  buttonCss,
  darkCardCss,
  solutionCardAsLinkCss,
  solutionCardCss,
} from './index.styles';

/**
 * This class component wraps the solutions card with a <div> or <a> tag depending
 * of the card Type. We have 2 types of cards, Free and none Free cards which depending
 * on if Cta.href is set they have different actions
 * Free card - w/o link = no action
 * Free card - w link = opens link
 * Non free card - w/o link = opens modal
 * Non free card - w link = opens link
 * Free cards are those which solution price prop is null.
 * @returns{React.Node}
 */
class SolutionCardType extends SafePureComponent {
  defaultFields = {
    Solution: get(this.props.fields, 'RelatedItemForm.value', ''),
    Location: this.props.location,
  };

  onClickHandler = openModal => openModal(modalIds.enquiry, this.defaultFields);

  handleRedirect(e, ctaHref) {
    e.preventDefault();

    Object.entries(this.defaultFields).forEach(([key, value]) => {
      window.sessionStorage.setItem(key, value);
    });

    window.location.href = ctaHref;
  }

  renderWrapper = openModal => {
    const { fields, children } = this.props;
    const styles = [solutionCardCss, fields.ShowAsBlackCard && darkCardCss];
    const ctaHref = get(fields, 'Cta.href');

    if (ctaHref) {
      return (
        <a
          href={ctaHref}
          onClick={e => this.handleRedirect(e, ctaHref)}
          data-item="solution-card"
          className="tab-element"
          target={get(fields, 'Cta.target')}
          css={[styles, solutionCardAsLinkCss]}
        >
          {children}
        </a>
      );
    }

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div
        data-item="solution-card"
        className="tab-element"
        role="button"
        tabIndex="0"
        onClick={() => fields.SolutionPrice && this.onClickHandler(openModal)}
        css={[
          styles,
          fields.SolutionPrice && solutionCardAsLinkCss,
          buttonCss(fields.SolutionPrice),
        ]}
      >
        {children}
      </div>
    );
  };

  safeRender() {
    return (
      <ModalsConsumer>
        {({ openModal }) => this.renderWrapper(openModal)}
      </ModalsConsumer>
    );
  }
}

SolutionCardType.propTypes = {
  fields: PropTypes.object.isRequired,
  location: PropTypes.string,
};

SolutionCardType.displayName = 'SolutionCardType';

export default SolutionCardType;
